import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { 
  Home, 
  Users, 
  Gift, 
  MessageSquare, 
  Bell, 
  Settings, 
  LogOut,
  ChevronRight
} from 'lucide-react';
import '../../assets/css/ngodashboard/Ngosidebar.css';

function Ngosidebar() {
  const [activeMenu, setActiveMenu] = useState('');
  const navigate = useNavigate();

  const menuItems = [
    { id: 'dashboard', icon: Home, label: 'Dashboard', path: '/ngo/dashboard' },
    { id: 'Withdrawal-management', icon: Users, label: 'Withdrawal Management', path: '/ngo/withdrawal-management' },
    { id: 'Level & badge', icon: Gift, label: 'Level & badge', path: '/ngo/level-badge' },
    { id: 'messages', icon: MessageSquare, label: 'Messages', path: '/ngo/messages' },
    { id: 'notifications', icon: Bell, label: 'Notifications', path: '/ngo/notifications' },
    { id: 'settings', icon: Settings, label: 'Settings', path: '/ngo/settings' }
  ];

  const handleMenuClick = (itemId) => {
    setActiveMenu(itemId);
  };

  const handleLogout = () => {
    localStorage.clear();
    navigate("/join-ngo");
  };

  return (
    <div className="sidebar-container">
      {/* Logo Section */}
      <div className="sidebar-logo-section">
        <div className="logo-circle">
          <Gift size={32} strokeWidth={2.5} />
        </div>
        <h2 className="panel-name">NGO Panel</h2>
      </div>

      {/* Menu Items */}
      <nav className="sidebar-menu">
        {menuItems.map((item) => {
          const Icon = item.icon;
          const isActive = activeMenu === item.id;
          
          return (
            <Link
              key={item.id}
              to={item.path}
              className={`menu-item ${isActive ? 'active' : ''}`}
              onClick={() => handleMenuClick(item.id)}
            >
              <div className="menu-content">
                <Icon size={20} className="menu-icon" />
                <span className="menu-label">{item.label}</span>
              </div>
              {isActive && <div className="active-indicator"></div>}
              <ChevronRight size={18} className="menu-arrow" />
            </Link>
          );
        })}
      </nav>

      {/* Logout Button */}
      <div className="sidebar-footer">
        <button className="logout-btn" onClick={handleLogout}>
          <LogOut size={20} />
          <span>Logout</span>
        </button>
      </div>
    </div>
  );
}

export default Ngosidebar;